import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwarePeriscopeClassicRoute: InvariantJiraRoute = {
	name: 'software-periscope-classic',
	path: '/jira/software/c/projects/:projectKey/development',
};
